import { render, staticRenderFns } from "./AddDiseases.vue?vue&type=template&id=56d3c61c"
import script from "./AddDiseases.vue?vue&type=script&lang=js"
export * from "./AddDiseases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports